// Shared browser download helpers for authenticated file exports.

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

// For axios responses fetched with { responseType: "blob" }.
export function downloadBinaryResponse(res, fallbackName) {
  const cd = res?.headers?.["content-disposition"] || "";
  const m = /filename\*?=(?:UTF-8''|")?([^";]+)"?/i.exec(cd);
  const name = (m && decodeURIComponent(m[1])) || fallbackName || "export.xlsx";
  downloadBlob(res.data, name);
}

// For JSON envelopes { filename, content_b64, mime } (exports_all.py).
export function downloadBase64Envelope(env, fallbackName) {
  const b64 = env?.content_b64 || "";
  const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  const blob = new Blob([bytes], { type: env?.mime || "application/octet-stream" });
  downloadBlob(blob, env?.filename || fallbackName || "export.xlsx");
}
